(function () {
    function getUTM() {
      const u = new URL(window.location.href);
      const keys = ["utm_source","utm_medium","utm_campaign","utm_content","utm_term"];
      const out = {};
      keys.forEach(k => { if (u.searchParams.get(k)) out[k] = u.searchParams.get(k); });
      return out;
    }
  
    function track() {
      if (window.location.pathname.startsWith("/admin")) return;
  
      const tokenTag = document.querySelector('meta[name="csrf-token"]');
      const csrf = tokenTag ? tokenTag.getAttribute("content") : "";
  
      fetch("/track/pageview", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrf
        },
        credentials: "same-origin",
        body: JSON.stringify({
          path: window.location.pathname + window.location.search,
          referrer: document.referrer,
          utm: getUTM()
        })
      });
    }
  
    document.addEventListener("DOMContentLoaded", track);
    document.addEventListener("turbo:load", track);
  })();  